import { InputNumber } from "antd";
import styled from "styled-components";

export const InputNumberStyled = styled(InputNumber)`
  .ant-input-number-handler-wrap {
    display: none;
  }
`;

export const Styles = styled.div`
  .ant-form-item-explain-error {
    font-size: 8px !important;
  }
  .ant-form-item {
    margin: 0px !important;
    line-height: 1;
  }
`;
